
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import img_404 from '../assets/images/img_404.svg';

import * as basicConstants from '../constants/basic';
import {
  FullImage,
  LinkCustom,
  FlexBoxColumnCenter
} from '../components/CustomComp';

import {
  BoxFlexColumnCenterCenter
} from '../components/customComponent';

import { ButtonGrey } from '../components/customComponent/button'

import theme from '../theme';

const Error = () => {
  document.title = `404${basicConstants.TITLE_PRODUCT_NAME}`;

  return (
    <BoxFlexColumnCenterCenter mt={3}>
      
      <FullImage src={img_404} alt="404 error" />
      
      <Typography
        align="center"
        sx={{
          marginTop: '3rem',
          marginBottom: '2.5rem'
        }}
      >
        您查詢的頁面不存在，可能已經移除或暫時無法使用。
      </Typography>
      <LinkCustom to='/'>
        <ButtonGrey variant="contained">回 {basicConstants.PRODUCT_NAME} 首頁</ButtonGrey>
      </LinkCustom>
    </BoxFlexColumnCenterCenter>
  );
}


export default Error;